import React, { FC, useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';

import { securableTypes } from '../../../../../constants';

import FormAntSwitch from '../FormAntSwitch';
import { renderToggleCell, toggleColumnProps } from '../permissionsTableColumns';
import ScrollablePermissionsTable from '../ScrollablePermissionsTable';

import '../PermissionsTable.css';

export interface IProps {
  treeItem: string;
  list: string[];
}

interface IRow {
  key: string;
  item: string;
  friendlyName: string;
}

const List: FC<IProps> = ({ list, treeItem }) => {
  const dataSource = useMemo(
    () =>
      list.map((item: string) => ({
        key: item,
        item,
        friendlyName: securableTypes[item]?.name ?? item
      })),
    [list]
  );

  const columns: ColumnsType<IRow> = useMemo(
    () => [
      {
        title: 'Название',
        dataIndex: 'friendlyName',
        key: 'friendlyName',
        ellipsis: false,
        className: 'sec-tree-permissions-table-role-col',
        onHeaderCell: () => ({ className: 'sec-tree-permissions-table-role-col' }),
        onCell: () => ({ className: 'sec-tree-permissions-table-role-col' })
      },
      {
        title: '',
        key: 'actions',
        ...toggleColumnProps,
        render: (_: unknown, record: IRow) =>
          renderToggleCell(
            <FormAntSwitch name={`actions.${treeItem}.${record.item}`} />
          )
      }
    ],
    [treeItem]
  );

  return (
    <ScrollablePermissionsTable
      className="sec-tree-permissions-table"
      size="small"
      bordered
      tableLayout="fixed"
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      rowKey="key"
    />
  );
};

export default List;
